import {
  apiAddNote,
  apiDeleteNote,
  apiGetNotes,
  apiUpdateNote,
} from "@lib/api/note";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useNoteQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || ["note", params ? JSON.stringify(params) : id];
  const queryClient = useQueryClient();

  const notesQuery = useQuery({
    queryFn: () => apiGetNotes(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addNoteMutation = useMutation({
    mutationFn: apiAddNote,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.note"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateNoteMutation = useMutation({
    mutationFn: apiUpdateNote,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.note"] as string,
        ),
      );
    },
  });

  const deleteNoteMutation = useMutation({
    mutationFn: apiDeleteNote,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.note"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    notesQuery,
    addNoteMutation,
    updateNoteMutation,
    deleteNoteMutation,
  };
};
